import React from 'react'
import { useRearrangeThemesMutation } from 'front-end/src/pages/manage-workspace-page/resources-subpage/ManageTheme.codegen'
import { WorkspaceManageTopicsAndThemesQuery } from 'front-end/src/pages/manage-workspace-page/resources-subpage/workspaceManageTopicsAndThemes.codegen'
import { useMutableArg } from 'front-end/src/app/hooks/useMutableArg'

export const useWorkspaceRearrangeThemes = (
  data: WorkspaceManageTopicsAndThemesQuery,
  workspaceId: number,
  refetch: () => Promise<unknown>
) => {
  const [themes, setThemes] = useMutableArg(data?.workspace?.themes ?? null)
  const isRearrangeInProgress = React.useRef(false)
  const [rearrangeResourcesGqlMutation, { loading }] =
    useRearrangeThemesMutation()

  const handleSortEnd = React.useCallback(
    async ({ newIndex, oldIndex }: { newIndex: number; oldIndex: number }) => {
      if (newIndex === oldIndex || !themes || isRearrangeInProgress.current) {
        return
      }
      isRearrangeInProgress.current = true
      const themesCopy = [...themes]
      // optimistic UI, rearrange elements while request in progress
      themesCopy.splice(newIndex, 0, themesCopy.splice(oldIndex, 1)[0])
      setThemes(themesCopy)

      try {
        // send request to GQL
        await rearrangeResourcesGqlMutation({
          variables: {
            themesIds: themesCopy.map((t) => t.id),
            workspaceId
          }
        })
      } finally {
        await refetch()
        isRearrangeInProgress.current = false
      }
    },
    [themes, workspaceId]
  )
  return { themes, handleSortEnd, loading }
}
